import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Sport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render() {
    const faqs = [
      { q: "❓ Это действительно бесплатно?", a: "Да. Никакой абонентской платы, процентов с броней. Оплата только за SMS и эквайринг (при подключении онлайн-оплаты). Бесплатно навсегда." },
      { q: "❓ Как клиенты ищут партнёра?", a: "При выборе времени они отмечают 'ищу партнёра'. Система объединяет их с другими пользователями. Как только пара набирается, бронь подтверждается автоматически." },
      { q: "❓ Могу ли я вносить брони вручную по телефону?", a: "Да. Администратор добавляет бронь в календарь за 10 секунд. Система отправит напоминания." },
      { q: "❓ Видят ли клиенты загрузку площадок?", a: "Да. Календарь месяца с цветовой индикацией: зелёные дни — свободно, красные — пик. Можно выбрать спокойное время." },
      { q: "❓ Нужно ли приложение для клиентов?", a: "Нет, достаточно браузера. Но есть и нативные приложения для iOS и Android." }
    ];

    return (
      <div class="fa-container">
        <Helmet>
          <title>Бронирование спортзала | Система для спорткомплексов — Planna</title>
          <meta name="description" content="Визуальная схема зала с выбором конкретного столика. Гости бронируют сами, вы видите загрузку в реальном времени. Бесплатно для ресторанов и кафе." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>

        {/* Hero */}
        <section className="hero">
          <div className="container fade-up">
            <div className="hero-badge">🎾 Для спортивных площадок | Бесплатно навсегда</div>
            <h1>Управляйте арендой кортов и полей <span className="highlight">онлайн, без тетрадки</span></h1>
            <p className="hero-description">Клиенты бронируют время сами, выбирают площадку, ищут партнёра для игры. Автоматические напоминания, аналитика загрузки, приём заявок по телефону. Всё бесплатно.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключить спорткомплекс бесплатно <i className="fas fa-play"></i></a>
            </div>
          </div>
        </section>

        {/* Преимущества (сетка) */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Всё для управления вашим спортивным объектом</h2>
              <p className="section-subtitle">Принимайте бронирования 24/7, заполняйте корты и поля, повышайте доход</p>
            </div>
            <div className="grid-3 fade-up">
              <div className="benefit-card"><i className="fas fa-calendar-alt benefit-icon"></i><h3>Онлайн-бронирование 24/7</h3><p>Клиенты сами выбирают дату, время и площадку. QR-код на стойке или в соцсетях.</p></div>
              <div className="benefit-card"><i className="fas fa-phone-alt benefit-icon"></i><h3>Брони по телефону — тоже в системе</h3><p>Администратор вносит заявки вручную за 10 секунд. Всё в одном календаре.</p></div>
              <div className="benefit-card"><i className="fas fa-users benefit-icon"></i><h3>Поиск партнёра для игры</h3><p>Клиент отмечает «ищу напарника» — система находит второго игрока. Бронирование подтверждается, когда пара собрана.</p></div>
              <div className="benefit-card"><i className="fas fa-chart-line benefit-icon"></i><h3>Аналитика загрузки</h3><p>Пиковые часы, популярные корты, доход — полный контроль.</p></div>
              <div className="benefit-card"><i className="fas fa-bell benefit-icon"></i><h3>Автоматические напоминания</h3><p>SMS, Telegram, push — снижение неявок до 70%.</p></div>
              <div className="benefit-card"><i className="fas fa-qrcode benefit-icon"></i><h3>QR-код для быстрой записи</h3><p>Разместите на стойке, в раздевалке — клиенты бронируют в один клик.</p></div>
            </div>
          </div>
        </section>

        {/* Скриншоты (замените src) */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Как это работает</h2>
              <p className="section-subtitle">Простой и удобный интерфейс для вас и ваших клиентов</p>
            </div>
            <div className="grid-2 fade-up" style={{ gap: '2.5rem' }}>
              <div className="screenshot-placeholder">
                <img src="{{mainApiUrl}}sportscheme1.png" alt="Выбор корта" />
                <div className="mockup-label">🎾 Схема кортов с выбором времени</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="{{mainApiUrl}}sportpartly1.png" alt="Поиск партнёра" />
                <div className="mockup-label">🤝 Отметьте «ищу партнёра»</div>
              </div>
              <div class="screenshot-placeholder">
                  <img src="{{mainApiUrl}}qrcode1.png" alt="QR-код"/>
                  <div class="mockup-label">📱 QR-код — запись за секунду</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="{{mainApiUrl}}notification1.png" alt="Напоминание" />
                <div className="mockup-label">🔔 Напоминания в push, Telegram/SMS</div>
              </div>
            </div>
          </div>
        </section>

        {/* Умные функции */}
        <section>
          <div className="container">
            {/* Поиск партнёра — главная фишка */}
            <div className="smart-block fade-up" style={{ marginTop: 0 }}>
              <div style={{ flex: 1 }}>
                <i className="fas fa-user-friends" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Никогда не играйте в одиночестве</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент хочет сыграть теннис, бадминтон или футбол, но не с кем? Он отмечает <strong>«ищу партнёра»</strong>. Система автоматически подбирает другого пользователя. Бронирование подтвердится, как только наберётся нужное количество участников. Вы получаете двух клиентов вместо одного.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Автоматический подбор пары (или команды)</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Заполняйте корты и поля в непиковые часы</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Увеличение дохода без дополнительных усилий</li>
                </ul>
              </div>
              <div style={{ flex: 1 }}>
                <div className="screenshot-placeholder">
                  <img src="{{mainApiUrl}}sportpartly1.png" alt="Поиск партнёра" />
                  <div className="mockup-label">🤝 Ищете напарника? Отметьте галочку</div>
                </div>
              </div>
            </div>

            {/* Календарь загрузки площадки */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-chart-line" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Календарь загрузки на месяц</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент видит цветовую индикацию занятости площадок: зелёные дни — свободно, красные — пик. Легко выбрать спокойное время для игры.</p>
                  <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Равномерное распределение нагрузки</li>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Повышение лояльности клиентов</li>
                  </ul>
                </div>
                <div style={{ flex: '0.9' }}>
                  <div className="screenshot-placeholder">
                    <img src="{{mainApiUrl}}calendar1.png" alt="Календарь загрузки" />
                    <div className="mockup-label">📅 Цветовая индикация загрузки</div>
                  </div>
                </div>
            </div>

            {/* Выбор по длительности слота */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem', flexDirection: 'row-reverse' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-clock" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Поиск по длительности</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент ищет окно на 1 час или 2,5 часа? Система покажет только подходящие слоты. Удобно для бизнес-ланча или полноценной тренировки.</p>
                  <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Быстрый поиск по времени</li>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Оптимальное заполнение расписания</li>
                  </ul>
                </div>
                <div style={{ flex: '0.9' }}>
                  <div className="screenshot-placeholder">
                    <img src="{{mainApiUrl}}shortslot1.png" alt="Поиск по длительности" />
                    <div className="mockup-label">⏱️ Поиск по длительности слота</div>
                  </div>
                </div>
            </div>

            {/* Два календаря при бронировании */}
            <div className="smart-block fade-up" style={{ background: 'linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)', marginTop: '2rem' }}>
                <div style={{ flex: 1 }}>
                  <div className="screenshot-placeholder">
                    <img src="{{mainApiUrl}}combined2.png" alt="Два календаря" />
                    <div className="mockup-label">📅 Два календаря – один выбор</div>
                  </div>
                </div>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-eye" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Совместный показ календарей</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент видит свои личные события из Google и Apple календаря (только в приложении) и свободные слоты площадки. Выбирает только свободное время.</p>
                  <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Без конфликтов с личными планами</li>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобный выбор времени</li>
                  </ul>
                </div>
            </div>
          </div>
        </section>

        {/* Подходит для видов спорта */}
        <section style={{ background: '#FEF9F0' }}>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Подходит для любых спортивных объектов</h2>
            <div className="stats-grid" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-table-tennis"></i><h3>Теннисные корты</h3><p>Поиск партнёра + онлайн-бронь</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-futbol"></i><h3>Футбольные поля</h3><p>Бронирование командных игр</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-badminton"></i><h3>Бадминтон / сквош</h3><p>Автоматический поиск пары</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-volleyball-ball"></i><h3>Волейбол / баскетбол</h3><p>Сбор команд по игрокам</p></div>
            </div>
          </div>
        </section>

        {/* Мобильные приложения */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="smart-block fade-up" style={{ background: 'white' }}>
              <div style={{ flex: 1 }}>
                <div className="screenshot-placeholder">
                  <img src="{{mainApiUrl}}mobile1.png" alt="Мобильное приложение" />
                  <div className="mockup-label">📱 Управляйте спорткомплексом со смартфона</div>
                </div>
              </div>
              <div style={{ flex: '1.2' }}>
                <i className="fas fa-mobile-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Мобильные приложения для всех</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Ваши сотрудники и клиенты могут пользоваться сервисом через нативные приложения для iOS и Android.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для бизнеса:</strong> управление бронями, расписанием, уведомления — с телефона</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для клиентов:</strong> поиск партнёра, бронирование, календарь</li>
                </ul>
                <div className="app-badges" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', margin: '20px 0 0 0' }}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" style={{ height: '45px' }} /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="https://play.google.com/intl/en_us/badges/static/images/badges/ru_badge_web_generic.png" alt="Google Play" style={{ height: '45px' }} /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

        {/* FAQ */}
        <section>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Частые вопросы</h2>
            <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} className={`faq-item ${this.state.activeFaq === idx ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => this.toggleFaq(idx)}>
                    {faq.q} <i className="fas fa-chevron-down"></i>
                  </div>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Призыв к действию */}
        <section style={{ background: 'linear-gradient(115deg, #1F2937 0%, #32bea6 100%)', color: 'white' }}>
          <div className="container fade-up" style={{ textAlign: 'center', padding: '80px 0' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '800' }}>Начните принимать бронирования уже сегодня</h2>
            <p style={{ fontSize: '1.1rem', margin: '1rem auto 2rem', maxWidth: '600px', opacity: 0.9 }}>Больше никаких бумажных журналов и потерянных заявок. Ваши корты и поля будут заполнены всегда.</p>
            <a href="/authentication/register" className="btn-filled btn-white">Зарегистрироваться <i className="fas fa-arrow-right"></i></a>
            <a href="/configcompany" className="btn-filled btn-white">Подключить бизнес бесплатно <i className="fas fa-arrow-right"></i></a>
            <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>Настройка за 15 минут. QR-код, напоминания, аналитика — 0₽</p>
          </div>
        </section>
      </div>
    );
  }
}
